/**
 * A8 · "Envío GRATIS el [fecha], haz el pedido en x h x mins x segs".
 * Cuenta atrás hasta la próxima hora de corte en día laborable; la entrega se estima sumando
 * días laborables de tránsito a la fecha de salida.
 */
const DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const laborable = (d) => d.getDay() !== 0 && d.getDay() !== 6;
const sumarLaborables = (fecha, n) => {
  const d = new Date(fecha);
  let quedan = n;
  while (quedan > 0) {
    d.setDate(d.getDate() + 1);
    if (laborable(d)) quedan--;
  }
  return d;
};
const corto = (d) => `${DIAS[d.getDay()]} ${d.getDate()} ${MESES[d.getMonth()]}`;
const dos = (n) => String(n).padStart(2, '0');

class LaEnvioCuenta extends HTMLElement {
  connectedCallback() {
    this.texto = this.querySelector('.la-envio-cuenta__texto');
    this.cortes = (this.dataset.cortes || '20:00')
      .split(',')
      .map((h) => h.trim().split(':').map(Number))
      .filter(([h]) => Number.isFinite(h))
      .sort((a, b) => a[0] * 60 + (a[1] || 0) - (b[0] * 60 + (b[1] || 0)));
    if (!this.cortes.length) return;
    this.tick = this.tick.bind(this);
    this.tick();
    this.intervalo = setInterval(this.tick, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.intervalo);
  }

  /** Próxima salida: el primer corte que quede hoy si es laborable; si no, el primero del siguiente laborable. */
  proximaSalida(ahora) {
    const dia = new Date(ahora);
    for (let i = 0; i < 8; i++) {
      if (laborable(dia)) {
        for (const [h, m = 0] of this.cortes) {
          const corte = new Date(dia);
          corte.setHours(h, m, 0, 0);
          if (corte > ahora) return corte;
        }
      }
      dia.setDate(dia.getDate() + 1);
      dia.setHours(0, 0, 0, 0);
    }
    return null;
  }

  tick() {
    const ahora = new Date();
    const salida = this.proximaSalida(ahora);
    if (!salida) return;
    const min = sumarLaborables(salida, Number(this.dataset.min || 1));
    const max = sumarLaborables(salida, Number(this.dataset.max || min));
    const fecha = min.getTime() === max.getTime() ? corto(min) : `${corto(min)} – ${corto(max)}`;
    const s = Math.max(0, Math.floor((salida - ahora) / 1000));
    const cuenta = `<strong>${Math.floor(s / 3600)} h ${dos(Math.floor((s % 3600) / 60))} mins ${dos(s % 60)} segs</strong>`;
    this.texto.innerHTML = (this.dataset.plantilla || '')
      .replace('{fecha}', `<strong>${fecha}</strong>`)
      .replace('{cuenta}', cuenta);
    this.texto.hidden = false;
  }
}

if (!customElements.get('la-envio-cuenta')) customElements.define('la-envio-cuenta', LaEnvioCuenta);
